import { get, tap } from 'lodash/fp';
import getFuncByMode from '../../utils/getFuncByMode';

import chuck from './chuck';
import mandi from './mandi';
import estimateLoaded from '../estimateLoaded';
import saveToMyAccount from '../saveToMyAccount';
import addEstimateToShareStoreSelection from '../share/addEstimateToSelection';
import reInitializeShareStoreSelection from '../share/initShareStore';
import loading from '../loading';
import loaded from '../loaded';
import globalError from '../globalError';
import safelyIncrement from '../../helpers/safelyIncrement';

const addDesign = getFuncByMode({
  chuck,
  mandi,
});

export default newDesignName => (dispatch, getState) => {
  dispatch(loading());

  const { estimateBuilder } = getState();

  const numberOfDesigns = get('entities.estimates.allIds.length', estimateBuilder);
  const currentDesignId = get('uiState.selectedEstimate', estimateBuilder);
  const currentDesign = get(`entities.estimates.byId.${currentDesignId}`, estimateBuilder);

  return addDesign(
    newDesignName || `Design ${safelyIncrement(numberOfDesigns)}`,
    currentDesign,
  )
    .then((designApiResponse) => {
      const designId = get('design.designId', designApiResponse);

      dispatch(estimateLoaded(designApiResponse));
      dispatch(saveToMyAccount(designId));
      dispatch(reInitializeShareStoreSelection());
      dispatch(addEstimateToShareStoreSelection(designId));

      return designApiResponse.design;
    })
    .then(tap(() => dispatch(loaded())))
    .catch(({ err }) => dispatch(globalError({ err })));
};
